(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-for-collections"] && !Shopify.designMode) return;
  try {
    

   class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer_spbkup"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_main"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Buy Now behavior
    document.body.addEventListener('click', (e) => {
      const buyNowBtn = e.target.closest('.buy-now');
      if (!buyNowBtn) return;

      e.preventDefault(); // Prevent default link behavior

      const variantId = buyNowBtn.dataset.variantId;
      if (!variantId) return;

      // Redirect to checkout with variant directly
      const checkoutUrl = `/cart/${variantId}:1/checkout`;
      window.location.href = checkoutUrl;
    });

    document.body.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('[data-cart-remove], .cart-remove-button');
      if (!removeBtn) return;

      e.preventDefault();

      const lineKey = removeBtn.dataset.lineKey; // or get from DOM
      if (!lineKey) return;

      // Send AJAX call to update cart (remove line)
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0
        })
      })
      .then((res) => res.json())
      .then((cart) => {
        // Update UI
        updateCartBadge();
        renderCart(cart); // you'd create this function to re-render items
      })
      .catch((err) => {
        console.error('Error removing item:', err);
      });
    });


    // Add to Cart behavior (AJAX)
    document.body.addEventListener('click', (e) => {
      const addToCartBtn = e.target.closest('.add-to-cart');
      if (!addToCartBtn) return;



      const variantId = addToCartBtn.dataset.variantId;
      const productTitle = addToCartBtn.dataset.productTitle || 'Item';

      if (!variantId) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        // Trigger your existing notification
        showNotification(productTitle);
        updateCartBadge();
      })
      .catch(err => {
        console.error('Error adding to cart:', err);
      });
    });
  });


  document.addEventListener('DOMContentLoaded', () => {
    const cartNotification = document.getElementById('cart-notification');
    const notificationMessage = document.getElementById('notification-message');
    if (!cartNotification || !notificationMessage) return;

    let cartUpdateTimeout;

    // Fetch latest cart and update badge
    const updateCartBadge = () => {
      fetch('/cart.js')
        .then((res) => res.json())
        .then((cart) => {
          const cartCount = cart?.item_count ?? 0;
          updateCartUI(cartCount);
          // console.log('Cart count updated:', cartCount);
        })
        .catch((err) => {
          console.error('Error fetching cart data:', err);
        });
    };

    // Debounced version (for quantity input changes)
    const triggerCartUpdate = () => {
      clearTimeout(cartUpdateTimeout);
      cartUpdateTimeout = setTimeout(updateCartBadge, 300);
    };

    // Update cart label in nav
    const updateCartUI = (count) => {
      document.querySelectorAll('.nav-item.cart').forEach((cartItem) => {
        const label = cartItem.querySelector('.badge-desktop-cart-count') || cartItem;
        label.textContent = `Cart (${count} Item${count === 1 ? '' : 's'})`;

        const labelMobile = cartItem.querySelector('.badge-mobile-cart-count') || cartItem;
        labelMobile.textContent = `(${count})`;
      });
    };

    // Show added to cart message
    const showNotification = (productTitle) => {
      if (!productTitle) return;
      notificationMessage.textContent = `"${productTitle}" has been added to your cart.`;
      cartNotification.classList.add('active');
      setTimeout(() => cartNotification.classList.remove('active'), 3000);
    };

    // Try to get product title from context
    const getProductTitleFromButton = (button) => {
      const productContainer = button.closest('.product, .product-card, .product-tile');
      return productContainer?.querySelector('.product__title, .card__heading')?.textContent?.trim();
    };

    // Add to Cart button clicked
    document.body.addEventListener('click', (e) => {
      const addToCartButton = e.target.closest('[data-add-to-cart], .add-to-cart, [type="submit"][name="add"]');
      if (!addToCartButton) return;

      const productTitle = addToCartButton.dataset.productTitle || getProductTitleFromButton(addToCartButton);
      if (productTitle) {
        setTimeout(() => showNotification(productTitle), 200);
        setTimeout(updateCartBadge, 500);
      }
    });

    // Quantity changes: plus, minus, remove
    document.body.addEventListener('click', (e) => {
      const isMinusBtn = e.target.closest('button[name="minus"]');
      const isPlusBtn = e.target.closest('button[name="plus"]');
      const isRemoveBtn = e.target.closest('[data-cart-remove], cart-remove-button');

      if (isMinusBtn || isPlusBtn || isRemoveBtn) {
        setTimeout(updateCartBadge, 500);
      }
    });

    // Manual input quantity change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.quantity__input')) {
        triggerCartUpdate();
      }
    });

    // Listen for Shopify AJAX add-to-cart event
    document.addEventListener('ajaxCart:afterProductAdd', (event) => {
      const productTitle =
        event.detail?.product?.title || document.querySelector('.product__title')?.textContent?.trim() || 'Item';
      showNotification(productTitle);
      setTimeout(updateCartBadge, 500);
    });

    // Initial load with slight delay
    setTimeout(updateCartBadge, 300);
  });

  // Hotline accordion toggle
  document.querySelector('.accordion-toggle')?.addEventListener('click', function () {
    const content = document.querySelector('.hotlines-content');
    const expanded = this.getAttribute('aria-expanded') === 'true';
    content?.classList.toggle('active');
    this.setAttribute('aria-expanded', !expanded);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const cartNotification = document.getElementById('cart-notification');
  const notificationMessage = document.getElementById('notification-message');
  let cartUpdateTimeout;

  // === Utility Functions ===

  const showNotification = (productTitle) => {
    if (!cartNotification || !notificationMessage || !productTitle) return;
    notificationMessage.textContent = `"${productTitle}" has been added to your cart.`;
    cartNotification.classList.add('active');
    setTimeout(() => cartNotification.classList.remove('active'), 3000);
  };

  const updateCartCountOnly = () => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const count = cart.item_count || 0;
        document.querySelectorAll('.badge-desktop-cart-count strong, .badge-mobile-cart-count strong')
          .forEach(el => el.textContent = count);
      })
      .catch(err => console.error('Error updating cart count:', err));
  };

  const debounceCartUpdate = () => {
    clearTimeout(cartUpdateTimeout);
    cartUpdateTimeout = setTimeout(updateCartCountOnly, 300);
  };

  const reloadCartSection = () => {
    fetch(window.location.pathname + '?sections=main-cart-items')
      .then(res => res.json())
      .then(data => {
        const cartContainer = document.querySelector('#main-cart-items');
        if (cartContainer && data['main-cart-items']) {
          cartContainer.innerHTML = data['main-cart-items'];
        }
      })
      .catch(err => console.error('Error reloading cart section:', err));
  };

  // === Event Listeners ===

  // Buy now button redirect
  document.body.addEventListener('click', (e) => {
    const buyNowBtn = e.target.closest('.buy-now');
    if (!buyNowBtn) return;

    e.preventDefault();
    const variantId = buyNowBtn.dataset.variantId;
    if (!variantId) return;

    window.location.href = `/cart/${variantId}:1/checkout`;
  });

  // Add to Cart button
  document.body.addEventListener('click', (e) => {
    const addToCartBtn = e.target.closest('.add-to-cart');
    if (!addToCartBtn) return;

    e.preventDefault();
    const variantId = addToCartBtn.dataset.variantId;
    const productTitle = addToCartBtn.dataset.productTitle || 'Item';
    if (!variantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(res => res.json())
      .then(() => {
        showNotification(productTitle);
        updateCartCountOnly();
        reloadCartSection();
      })
      .catch(err => console.error('Error adding to cart:', err));
  });

  // Remove item from cart & update count + reload section
 // Remove item from cart & update count + reload section
document.body.addEventListener('click', (e) => {
  const removeBtn = e.target.closest('[data-cart-remove], .cart-remove-button');
  if (!removeBtn) return;

  e.preventDefault();
  const lineKey = removeBtn.dataset.lineKey;
  if (!lineKey) return;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: 0 }),
  })
    .then(res => res.json())
    .then(() => {
      updateCartCountOnly(); // update count right away

      // delay cart reload by 500ms
      setTimeout(() => {
        reloadCartSection();
      }, 500);
    })
    .catch(err => console.error('Error removing item:', err));
});


  // Handle clicks on plus/minus buttons & removals (update count + reload)
  document.body.addEventListener('click', (e) => {
    const target = e.target.closest('button[name="minus"], button[name="plus"]');
    if (target) {
      setTimeout(() => {
        updateCartCountOnly();
        reloadCartSection();
      }, 500);
    }
  });

  // Handle manual quantity input changes (debounced)
  document.body.addEventListener('change', (e) => {
    if (e.target.matches('.quantity__input')) {
      debounceCartUpdate();
      reloadCartSection();
    }
  });

  // Initial cart count update on page load
  updateCartCountOnly();

  // Optional: toggle accordion for hotlines or other UI elements
  document.querySelector('.accordion-toggle')?.addEventListener('click', function () {
    const content = document.querySelector('.hotlines-content');
    const expanded = this.getAttribute('aria-expanded') === 'true';
    content?.classList.toggle('active');
    this.setAttribute('aria-expanded', !expanded);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
